import {
  Component,
  Injector,
  Optional, SecurityContext
} from '@angular/core';
import {CommonModule} from "@angular/common";

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  TrustAsPipe
} from "@wm/components-base";
import {SafeResourceUrl} from "@angular/platform-browser";
import {encodeUrl, isInsecureContentRequest} from "@wm/core";
import {isString} from "lodash-es";

const DEFAULT_CLS = 'embed-responsive app-iframe';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-iframe',
  hostClass: DEFAULT_CLS
};

@Component({
  selector: '[wmIframe]',
  template: `
    <iframe class="embed-responsive-item iframe-content" role="document" [name]="name" [attr.src]="_iframesrc" (load)="iframeLoaded($event)"></iframe>
    <div class="wm-content-info readonly-wrapper iframe-error-content" *ngIf="showContentLoadError">
    <p class="wm-message iframe-error-message" [title]="hintMsg" [textContent]="errorMsg"></p>
    </div>
<!--    TODO: remove this tag and use directive here-->
    <div class="wm-widget-overlay-inner"></div>
  `,
  providers: [
    provideAsWidgetRef(IframeComponent),
    TrustAsPipe
  ],
  exportAs: 'wmIframe',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class IframeComponent extends StylableComponent {
  static initializeProps = register('wm-iframe');

  public iframesrc: string;
  public encodeurl: boolean;

  public _iframesrc: SafeResourceUrl | null;
  public errorMsg: string;
  public hintMsg: string;

  public caption: any;
  public name: string;
  public hint: string;
  public showContentLoadError = false;

  constructor(inj: Injector,
              @Optional() viewParent: Parent, private trustAsPipe: TrustAsPipe) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  protected iframeLoaded($event: Event) {
    try {
      const iframeWindow = ($event.target as HTMLIFrameElement).contentWindow;
      if (iframeWindow) {
        const loaded = iframeWindow.document; // Accessing the document to check for load issues
      }
    } catch (error: any) {
      this.showContentLoadError = true;
      this.errorMsg = this.appLocale.LABEL_IFRAMESRC_ERRORMSG;
      this.hintMsg = this.appLocale.LABEL_IFRAMESRC_HINTMSG;
    }
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'iframesrc') {
      if (nv && isString(nv) && nv.indexOf('Variables') === -1){
        nv = this.encodeurl ? encodeUrl(nv) : nv;
        if (this.isRelativeUrl(nv) || nv.startsWith('http://') || isInsecureContentRequest(nv)) {
          // Block relative URLs, HTTP URLs, and insecure content requests
          this.showContentLoadError = true;
          this.errorMsg = this.appLocale.LABEL_IFRAMESRC_RESTRICTION_MSG;
          this.hintMsg = this.errorMsg;
          this._iframesrc = null;
        } else {
          this.showContentLoadError = false;
          this._iframesrc = this.trustAsPipe.transform(nv, SecurityContext.RESOURCE_URL);
        }
      }
    }
    super.onPropertyChange(key, nv, ov);
  }

  // Helper function to check if a URL is relative
  private isRelativeUrl(url: string): boolean {
    // A relative URL does not start with a protocol or `//`
    return !/^(?:[a-z]+:)?\/\//i.test(url);
  }
}

